module.exports = __webpack_public_path__ + "img/p_2.30721a4c.jpg";